/**
 * 流失综合分析
 */
import { LOSSINGSTAT } from '../types';

export default {
    name: `${LOSSINGSTAT}`,
    path: '/lossingStat',
    component: () => import(/* webpackChunkName: 'lossingStat' */ '@/views/lossingStat/'),
    redirect: { name: `${LOSSINGSTAT}Index` },
    meta: {
        title: '流失综合分析',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${LOSSINGSTAT}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'lossingStat' */ '@/views/lossingStat/home/Home.vue'),
        },
    ],
};
